const envKeys = {
    app: '61bf2ae2b0860914dc7e64d8',
    preprod: '61bf2ae2b0860914dc7e64d8',
    staging: '61bf2d252ce77f157596b1db',
    dev: '61c86d58bb6da91318f0783a',
    rc: '61bf2d61b0860914dc7e653a',
}

export default envKeys;